import type { AskDisplay } from '../../types';
import { BangKetQua } from './BangKetQua';
import { BieuDo, LA_BIEU_DO } from './BieuDo';

/**
 * Biểu đồ + bảng của một lượt. MỘT chỗ vẽ, dùng cho cả lượt đang chạy lẫn lượt đọc lại từ CSDL — trước đây mở lại một
 * đoạn chat cũ là mất sạch biểu đồ và bảng: cùng câu trả lời, hai hình dạng, tuỳ lúc người ta nhìn.
 */
export function KhoiSoLieu({
  rows,
  columns,
  nhanCot,
  display,
  veBang,
  hoiDanhSach,
  daCat,
}: {
  rows?: Record<string, unknown>[];
  columns?: string[];
  nhanCot?: Record<string, string>;
  display?: AskDisplay;
  /** Lượt này có CẦN bảng không — máy chủ quyết. Lời văn vừa kể đủ tên kèm số thì bảng chỉ là những con số ấy lần hai. */
  veBang?: boolean;
  /** Đường lùi cho lượt CŨ (trước khi có `veBang`). Giữ ở đây, một chỗ — bốn bản sao của một luật là bốn chỗ để quên. */
  hoiDanhSach?: boolean;
  /** Số liệu lưu lại đã bị cắt dòng: KHÔNG vẽ biểu đồ — một biểu đồ dựng từ phần dữ liệu là một hình nói sai. */
  daCat?: { luu: number; tong: number };
}) {
  if (!rows?.length) return null;
  const ve = veBang ?? hoiDanhSach;
  return (
    <>
      {!daCat && display?.theoYeuCau && LA_BIEU_DO.has(display.dang) ? <BieuDo rows={rows} dang={display} /> : null}
      {ve ? (
        <BangKetQua columns={columns ?? Object.keys(rows[0] ?? {})} rows={rows} nhan={nhanCot} className="mt-3" />
      ) : null}
    </>
  );
}
